export default "__VITE_ASSET__1wvCPKpk__"